import { createDirectus, rest, triggerFlow, staticToken } from "@directus/sdk";

// Universal email sender compatible with EmailJS and Directus.
// Signature matches required params: email, test, fio, result, sendInfo, pdfUrl
export async function sendEmail(email, test, fio, result, pdfUrl, sendInfo) {
  try {
    const client = createDirectus(sendInfo.baseUrl)
      .with(rest())
      .with(staticToken(sendInfo.token));

    // Match keys to what the Directus Flow template expects
    const payload = {
      fio,
      name: fio,
      test,
      result,
      pdf_url: pdfUrl,
      to: email || sendInfo?.to,
      // Keep also subject/message for potential alternative templates
      subject: `${sendInfo.subjectPrefix}: ${test} – ${fio}`,
      message: `
        <h2>${test}</h2>
        <p><b>ФИО:</b> ${fio}</p>
        <pre>${result}</pre>
        ${pdfUrl ? `<p><a href="${pdfUrl}" target="_blank">📄 Скачать PDF</a></p>` : ""}
      `,
    };

    console.log('→ payload to Directus:', payload);

    const method = sendInfo?.method || 'POST';
    const response = await client.request(triggerFlow(method, sendInfo.flowId, payload));

    console.log('✅ Письмо успешно отправлено:', response);
    return response;

  } catch (error) {
    console.error('❌ Ошибка при отправке письма:', error);
    throw error;
  }
}


export default sendEmail;


